import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Beaker = createReactComponent("Beaker", ["svg", defaultAttributes, [["path", {
  d: "M4.5 3h15",
  key: "1qrsw4"
}], ["path", {
  d: "M6 3v16a2 2 0 002 2h8a2 2 0 002-2V3",
  key: "z0qw0"
}], ["path", {
  d: "M6 14h12",
  key: "79jpmc"
}]]]);
export default Beaker;